<template>
  <list-view-cell :context-menu-items="contextMenuItems">
    <p class="font-bold">{{ contact.name }}</p>
    <p class="text-sm">
      <i class="fal fa-monument fa-fw" />
      <span class="ml-1 uppercase">{{ contact.type }}</span>
    </p>
    <p class="mt-3">{{ contact.companyName }}</p>
    <p>
      <a class="text-red hover-bold" :href="`mailto:${contact.email}`">
        {{ contact.email }}
      </a>
    </p>
    <p>{{ contact.phone }}</p>
  </list-view-cell>
</template>

<script>
import ListViewCell from "../ListViewCell";
import { ContextMenuItem } from "../../../../helper-classes/ContextMenuItem";
import ContractContactForm from "../../../../views/contracts/forms/ContractContactForm";

export default {
  name: "ContactCell",
  components: { ListViewCell },
  props: {
    contact: Object
  },
  data() {
    return {
      contextMenuItems: [
        new ContextMenuItem("edit", () => {
          this.$store.commit("setCreateEditComponentParams", {
            createEditComponent: ContractContactForm,
            createEditComponentData: this.contact,
            createEditComponentIsShown: true
          });
        }),
        new ContextMenuItem("delete", () => {
          this.$store.commit("setConfirmationModalParams", {
            type: "delete",
            headerText: "Delete Confirmation",
            bodyComponent: undefined,
            bodyComponentData: this.contact,
            isShown: true
          });
        })
      ]
    };
  }
};
</script>

<style scoped></style>
